import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ODataService } from 'src/app/core/services/odata.service';
import { SocEvent } from 'src/app/core/models/entities';

@Injectable({ providedIn: null })
export class MttdDetailsService extends ODataService<SocEvent> {
  private field = 'alert_received_on';

  constructor() {
    super(inject(HttpClient), '');
    this.state = {
      skip: 0,
      take: 10,
      sort: [{ field: this.field, dir: 'desc' }],
      filter: {
        logic: 'and',
        filters: [],
      },
    };
  }

}
